import * as tooltip from "../../../controls/TooltipControls";
import { ComponentEx } from "../../../controls/ComponentEx";
import { setCreateTransfer, setSource, setTarget, } from "../actions/transferSetup";
import * as selectors from "../selectors";
import * as React from "react";
import { Overlay, Popover } from "react-bootstrap";
import { DragSource, DropTarget } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { findDOMNode } from "react-dom";
import { connect } from "react-redux";
function componentCenter(component) {
    const domNode = findDOMNode(component);
    const box = domNode.getBoundingClientRect();
    return {
        x: box.left + box.width / 2,
        y: box.top + box.height / 2,
    };
}
// what a hack... :(
// react-dnd seems to completely block the mousemove event so the monitor seems to be
// the only way to get at the cursor position. It doesn't fire events on movement though
let cursorPosUpdater;
let lastUpdatePos = { x: 0, y: 0 };
function updateCursorPos(monitor, component, onSetSource, onSetTarget) {
    if (monitor.getClientOffset() !== null) {
        const curPos = monitor.getClientOffset();
        const dist = Math.abs(curPos.x - lastUpdatePos.x) +
            Math.abs(curPos.y - lastUpdatePos.y);
        if (dist > 2) {
            lastUpdatePos = curPos;
            onSetTarget(null, curPos);
        }
    }
    cursorPosUpdater = setTimeout(() => updateCursorPos(monitor, component, onSetSource, onSetTarget), 50);
}
const transferSource = {
    beginDrag(props, monitor, component) {
        props.onSetHighlightGameId(props.profile.gameId);
        updateCursorPos(monitor, component, props.onSetSource, props.onSetTarget);
        return {
            id: props.profile.id,
        };
    },
    endDrag(props, monitor) {
        props.onSetHighlightGameId(undefined);
        clearTimeout(cursorPosUpdater);
        cursorPosUpdater = undefined;
        const source = monitor.getItem();
        props.onSetSource(source.id, undefined);
        if (monitor.getDropResult() === null) {
            return;
        }
        const destId = monitor.getDropResult().id;
        if (source.id !== destId) {
            props.onEditDialog(props.profile.gameId, source.id, destId);
        }
    },
    canDrag(props) {
        return !props.disabled;
    },
};
const transferTarget = {
    drop(props, monitor, component) {
        return {
            id: props.profile.id,
        };
    },
};
function collectDrag(dragConnect, monitor) {
    return {
        connectDragSource: dragConnect.dragSource(),
        connectDragPreview: dragConnect.dragPreview(),
        isDragging: monitor.isDragging(),
    };
}
function collectDrop(dropConnect, monitor) {
    const item = monitor.getItem();
    return {
        connectDropTarget: dropConnect.dropTarget(),
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
        sourceId: item !== null ? item.id : undefined,
    };
}
class TransferIcon extends ComponentEx {
    mIsMounted;
    mRef;
    constructor(props) {
        super(props);
        this.initState({ showOverlay: false });
        this.mIsMounted = false;
    }
    componentDidMount() {
        this.mIsMounted = true;
        this.props.connectDragPreview(getEmptyImage());
    }
    componentWillUnmount() {
        this.mIsMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.isDragging !== nextProps.isDragging) {
            let pos;
            if (nextProps.isDragging) {
                pos = componentCenter(this);
            }
            nextProps.onSetSource(nextProps.profile.id, pos);
        }
        else if (this.props.isOver !== nextProps.isOver) {
            if (this.props.profile.id !== nextProps.sourceId &&
                nextProps.sourceId !== undefined &&
                this.props.profile.gameId ===
                    this.props.profiles[nextProps.sourceId].gameId) {
                let pos;
                if (nextProps.isOver) {
                    pos = componentCenter(this);
                }
                nextProps.onSetTarget(nextProps.profile.id, pos);
            }
        }
    }
    render() {
        const { t, connectDragSource, connectDropTarget, disabled, profile } = this.props;
        const classes = ["btn-embed"];
        const popoverBlocks = [];
        if (popoverBlocks.length > 0) {
            classes.push("btn-transfer-hasOptions");
        }
        else {
            popoverBlocks.push(t("Drag to another profile to transfer settings."));
        }
        const popover = (React.createElement(Popover, { id: `popover-${profile.id}`, style: { maxWidth: 500 } }, popoverBlocks));
        const connectorIcon = connectDragSource(React.createElement("div", { style: { display: "inline-block" } },
            React.createElement(tooltip.IconButton, { id: `btn-meta-data-${profile.id}`, disabled: disabled, className: classes.join(" "), key: `rules-${profile.id}`, tooltip: t("Drag to another profile to transfer settings."), icon: "connection", ref: this.setRef, onClick: this.toggleOverlay }),
            React.createElement(Overlay, { show: this.state.showOverlay, onHide: this.hideOverlay, placement: "left", rootClose: true, target: this.mRef }, popover)));
        return connectDropTarget(React.createElement("div", { style: { textAlign: "center", display: "inline-block" } }, connectorIcon));
    }
    setRef = (ref) => {
        this.mRef = ref;
    };
    toggleOverlay = () => {
        this.nextState.showOverlay = !this.state.showOverlay;
    };
    hideOverlay = () => {
        this.nextState.showOverlay = false;
    };
}
const type = "profile-transfer-icon";
const TransferIconDrag = DropTarget(type, transferTarget, collectDrop)(DragSource(type, transferSource, collectDrag)(TransferIcon));
function mapStateToProps(state) {
    return {
        gameId: selectors.activeGameId(state),
        profiles: state.persistent.profiles,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetSource: (id, pos) => dispatch(setSource(id, pos)),
        onSetTarget: (id, pos) => dispatch(setTarget(id, pos)),
        onEditDialog: (gameId, source, target) => dispatch(setCreateTransfer(gameId, source, target)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(TransferIconDrag);
